import { GitPullGitError } from '../errors/git-pull.git-error';
import { setToken } from '../util/set-token';
import type { WorkerAction, WorkerFnParams } from '../wasm-git.worker.model';
import type { GitAction } from './actions.enum';

export interface GitPullAction extends WorkerAction {
  type: GitAction.Pull;
  params: { branch: string; authToken: string };
}

export async function GitPullActionFn({ lg, util, params }: WorkerFnParams<GitPullAction>): Promise<void> {
  const { branch, authToken } = params;
  try {
    setToken(authToken);
    lg.callAndCaptureOutput(['fetch', 'origin']);
    lg.callAndCaptureOutput(['merge', `origin/${branch}`]);
    await util.syncfs(false);
  } catch (err: unknown) {
    throw new GitPullGitError((err as Error).message);
  }
}
